import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStaticQuery, graphql, Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import nerthusLogo from '../assets/images/nerthusLogo.svg';
import { NERTHUS_LINK, NERTHUS_LINKS_ENABLED } from '../constants';
import GenericLink from './GenericLink';
import Menu from './Menu';
import DropDownMenu from './DropDownMenu';
import MenuButton from './MenuButton';

import * as styles from './Header.module.scss';

import logoSvg from '../assets/images/logos/ASCENZA_logo.svg';

interface HeaderProps {
  isMenuOpen: boolean;
  onHamburguerMenuTouch: () => void;
}

const Header = ({ isMenuOpen, onHamburguerMenuTouch }: HeaderProps): React.ReactElement => {
  const { t } = useTranslation();
  const data: any = useStaticQuery(
    graphql`
      {
        sanityWebsite {
          topBar {
            leftSideLinks {
              title
              url
            }
            rightSideLinks {
              title
              url
            }
          }
        }
      }
    `,
  );

  const topBar = data.sanityWebsite.topBar || {};

  return (
    <header className={styles.header}>
      {((topBar.leftSideLinks && topBar.leftSideLinks.length > 0) ||
        (topBar.rightSideLinks && topBar.rightSideLinks.length > 0)) && (
        <div className={styles.topNavBar}>
          {topBar.leftSideLinks && topBar.leftSideLinks.length > 0 && (
            <div className={styles.leftSideLinks}>
              {topBar.leftSideLinks.map((link, i) => (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  key={i}
                  href={link.url}
                  className={styles.externalLink}
                >
                  {link.title}
                </a>
              ))}
            </div>
          )}

          {topBar.rightSideLinks && topBar.rightSideLinks.length > 0 && (
            <div className={styles.rightSideLinks}>
              {topBar.rightSideLinks.map((link, i) => (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  key={i}
                  href={link.url}
                  className={styles.externalLink}
                >
                  {link.title}
                </a>
              ))}
            </div>
          )}
        </div>
      )}

      <section className={styles.navBar}>
        <div className={styles.container}>
          <Link to="/" className={styles.logoContainer}>
            <img className={styles.logo} src={logoSvg} alt="Ascenza Logo" />
          </Link>
          <div className={styles.menuCountryAndNerthus}>
            <div className={styles.countryAndNerthus}>
              <span className={styles.country}>
                <FontAwesomeIcon icon="map-marker-alt" className={styles.icon} />
                &nbsp;{t('country_name', 'Portugal')}
              </span>
              {NERTHUS_LINKS_ENABLED && (
                <GenericLink
                  className={styles.nerthusButton}
                  noUnderline
                  noExternalUrlIcon
                  to={NERTHUS_LINK}
                >
                  {t('nerthus.project_name', 'Nerthus Sustainability')}
                </GenericLink>
              )}
            </div>
            <div className={styles.menuWrapper}>
              <Menu></Menu>
            </div>
          </div>
          <div className={styles.hamburgerMenu}>
            <MenuButton
              label={t('header.mobile_menu_label', 'Menu')}
              icon="hamburger"
              isMenuOpen={isMenuOpen}
              onTouch={onHamburguerMenuTouch}
            ></MenuButton>
          </div>
        </div>
      </section>
      <div className={styles.shadow}></div>
      <div className={styles.dropDownMenuWrapperWindow}>
        <div className={styles.dropDownMenuWrapper + (isMenuOpen ? ' ' + styles.menuOpen : '')}>
          <DropDownMenu></DropDownMenu>
        </div>
      </div>
    </header>
  );
};

export default Header;
